import { createRouter, createWebHistory } from 'vue-router'
import auth from '@/middleware/auth';
import permission from '@/middleware/permission';
import guest from '@/middleware/guest';
import store from '@/store';
import middlewarePipeline from '@/middleware/pipeline';

const routes = [
	{
		path: '/login',
		component: () => import('../layouts/EmptyLayout.vue'),
		children: [
			{
				path: '',
				name: 'login',
				component: () => import('../views/Auth/AuthLogin.vue'),
				meta: {
					middleware: [guest]
				}
			}
		]
	},
	{
		path: '/',
		component: () => import('../layouts/MainLayout.vue'),
		children: [
			{
				path: '/403',
				name: '403',
				component: () => import('../views/Errors/403.vue')
			},
			{
				path: '/404',
				name: '404',
				component: () => import('../views/Errors/404.vue')
			},
			{
				path: '/',
				name: 'home',
				component: () => import('../views/Dashboard/Index.vue'),
				meta: {
					middleware: [auth]
				}
			},
			{
				path: '/events',
				name: 'events.index',
				component: () => import('../views/Events/Index.vue'),
				meta: {
					middleware: [auth, permission],
					permission: 'event_index'
				}
			},
			{
				path: '/events/:id',
				name: 'events.show',
				component: () => import('../views/Events/Show.vue'),
				meta: {
					middleware: [auth, permission],
					permission: 'event_show'
				}
			},
			{
				path: '/channels',
				name: 'channels.index',
				component: () => import('../views/Channels/Index.vue'),
				meta: {
					middleware: [auth, permission],
					permission: 'channel_index'
				}
			},
			{
				path: '/channels/:id',
				name: 'channels.show',
				component: () => import('../views/Channels/Show.vue'),
				meta: {
					middleware: [auth, permission],
					permission: 'channel_show'
				}
			},
			{
				path: '/users',
				name: 'users.index',
				component: () => import('../views/Users/Index.vue'),
				meta: {
					middleware: [auth, permission],
					permission: 'user'
				}
			},
			{
				path: '/users/:id',
				name: 'users.show',
				component: () => import('../views/Users/Show.vue'),
				meta: {
					middleware: [auth, permission],
					permission: 'user'
				}
			},
			{
				path: '/roles',
				name: 'roles.index',
				component: () => import('../views/Roles/Index.vue'),
				meta: {
					middleware: [auth, permission],
					permission: 'role'
				}
			},
			{
				path: '/permissions',
				name: 'permissions.index',
				component: () => import('../views/Permissions/Index.vue'),
				meta: {
					middleware: [auth, permission],
					permission: 'permission'
				}
			}
		]
	}
]

const router = createRouter({
	history: createWebHistory(),
	routes
})


router.beforeEach(async (to, from, next) => {
	if (!to.meta.middleware) {
		return next()
	} else {
		const middleware = to.meta.middleware

		const context = {
			to,
			from,
			next,
			router,
			store: store,
			permission: to.meta.permission
		}


		return middleware[0]({
			...context,
			next: middlewarePipeline(context, middleware, 1)
		})
	}
});

export default router